const colors = {
  primaryGreen: "#7f9b7e", // accent color
  lightCream: "#F6F6F4", // text color 1
  black: "#000000",
  // white: "#FFFFFF",
  lightPastelGreen: "#D7E6D9",
  pastelGreen: "#B5CFB7",
  pastelCream: "#FCF5E5", // background color 1
  darkBrown: "#4B3F38", // primary color
  pantoneBrown: "#A47764",
  veryDarkBrown: "#2D2424",
};

export default colors;
